import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Button, TextField } from '@material-ui/core';
import { setSettings,navigateTo,getSettings,setError, setSuccess} from '../../redux/actions'
import Loading from '../common/loading';
import BackToPage from '../common/back-to-page';
import { colors,patientGoalBaseStyles } from '../../theme/style';
import AdminLayout from '../user/admin/AdminLayout';
import { urls } from '../../utils/Objects';
import Alerts from '../common/Alerts';



class PatientGoal extends Component {
  constructor(props) {
    super(props);

   this.state = {
      new: false,
      complianceHours: '-1',
      isDone: true
    };

  this.updateIsDone = this.updateIsDone.bind(this);
}
  componentDidMount()
  {
    this.props.getSettings(this.props.selectedPatient.id)

  }
  componentWillUnmount(){
    this.resetMessages()


  }

 
  updateIsDone = ()=> {
    this.setState({isDone:true});
  }


  handleChange = event => {
    this.resetMessages()
    this.setState({ [event.target.name]: event.target.value })
  };

  resetMessages =()=>{
    this.props.setSuccess("")
    this.props.setError("")
  }
  
  
  handleSave = () => {
    if(this.state.complianceHours > 25){
      this.props.setError("cannot set compliance goal to more than 25 ")
      return
    }
    this.setState({isDone:false});
    
    const patientId = this.props.selectedPatient.id
    this.props.setSettings(patientId,{"serial_number":null ,"compliance_hours": this.state.complianceHours },this.updateIsDone)
  };
  

  
  static getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.settings!=null&&prevState.complianceHours=='-1'&&nextProps.settings.complianceHours !== prevState.complianceHours) {
      return ({ complianceHours: nextProps.settings.complianceHours }) // <- this is setState equivalent
    }
    return null
  }


  render() {
    let name_display=this.props.selectedPatient?.firstName;
    let birth_date_display=this.props.selectedPatient.birth_date;
    // this.props.settings?this.setState({complianceHours:this.props.settings.complianceHours}):this.setState({compliance_hours:0})
    if ( this.state.complianceHours=='-1') {
      return <Loading />;
    }
    if (this.props.selectedPatient.firstName && this.props.selectedPatient.lastName) {
      name_display = <h1>{this.props.selectedPatient.firstName} {this.props.selectedPatient.lastName}</h1>;
    }
    if(!this.props.settings)
    return <Loading />;

    return (<AdminLayout {...this.props}>
    <Alerts />
      <section style={patientGoalBaseStyles.container}>
        <div navstyle={patientGoalBaseStyles.navstyle}>
          <BackToPage link={urls.patients} text="Patient List"/>
        </div>

       <div style={patientGoalBaseStyles.patientName} >{name_display}</div>
        <div style={patientGoalBaseStyles.birthDate}>
          Birth Date: &nbsp;
          {moment(birth_date_display).format('MMM D,YYYY')}
        </div>


        <div style={patientGoalBaseStyles.compliance}>
          <section style={patientGoalBaseStyles.margin}>
            Compliane Hours
            <TextField
              name="complianceHours"
              placeholder="Compliance Hours"
              style={patientGoalBaseStyles.textField}
              value={Number(this.state.complianceHours)}
              onChange={this.handleChange.bind(this)}
              type="number"
            />
            <br/>
          </section>
          <section style={patientGoalBaseStyles.btns}>
            <Button
              color={this.state.isDone ? "primary" : "secondary"}
              variant="contained"
              style={patientGoalBaseStyles.saveBtn}
              // disabled={!this.state.complianceHours || cobbSettings.editCobbSettingsPending || cobbSettings.addCobbSettingsPending}
              disabled={!this.state.complianceHours}
              onClick={this.handleSave}
            >
              {this.state.new ? 'Save' : 'Update'}
            </Button>
            <div style={styles.success}>{this.props.user.succesMessage}</div>
            <div style={styles.error}>{this.props.user.error}</div>
          </section>
        </div>
      </section>
    </AdminLayout>);
    }
  }


  const mapStateToProps = (state,ownProps) => {
    const selectedPatient = ownProps.location.state;
    return (
        {
            login: state.login,
            user: state.user,
            settings:state.user.patient.settings,
            selectedPatient:selectedPatient
        }
    )
}
const styles = {
  error: {
    color: "#ea0404",
  },
  success: {
    color: "#4CAF50",
  },
}
const mapDispatchToProps = {
    
    navigateTo,
    setSettings,
    getSettings,
    setError,
    setSuccess,
  }

export default connect(mapStateToProps, mapDispatchToProps)(PatientGoal)